<template>
    <button class="flex items-center justify-center bg-white w-9 h-9 rounded-full shadow-md hover:bg-gray-50 transition ease-in-out duration-150">
        <i :class="`text-sm fas ${icon} ${colorIcon}`"></i>
    </button>
</template>
<script>
export default {
    name: 'ButtonIcon',
    props: {
        icon: { type: String, required: true },
        colorIcon: { type: String }
    }
}
</script>
